<template>
  <div class="backTo">
    <div class="img" @click="backTo"></div>
  </div>
</template>
<script>
export default {
  name: 'back',
  props: {
    path: {
      type: String,
      default: ''
    }
  },
  methods: {
    backTo() {
      this.$router.push({
        path: this.path
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.backTo {
  position: fixed;
  bottom: 80px;
  left: 24px;
  z-index: 999999999999;
  .img {
    width:71px;
    height:71px;
    border-radius: 50%;
    box-shadow:0px 0px 20px 0px rgba(3,177,135,0.3);
    background-image: url('../../assets/back.png');
    background-size: 100% 100%;
  }
}
</style>